<template>
    <KPIPage></KPIPage>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const KPIPage = defineAsyncComponent(() =>
    import("../../components/Hr/KPI/KPI.vue")
);

export default {
    name: "KPIPage_HR",
    components: { KPIPage, AuthLayout },
};
</script>

<style scoped></style>
